import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';

export class MultiAccessCompanyContainer {
  chargeable_guids: string[];
  non_chargeable_guids: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ClaimantMultiCompanyAccessService extends BaseApiTemplateService<MultiAccessCompanyContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    'companies/public/claims/custom-multiple-company-access/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      'companies/public/claims/custom-multiple-company-access/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      'companies/public/claims/custom-multiple-company-access/backoffice-ep';
    this.httpClient = http;
  }

  getCompaniesByClaimantGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<MultiAccessCompanyContainer>> {
    let url = Core2Config.DOMAIN_URL +
      'core2/tnt/dm/erp/companies/public/claims/custom-multiple-company-access/backoffice-ep?claimant_entity_hdr_guid=' + guid;
    if (visa.api_domain_url) {
      url = visa.api_domain_url +
        'core2/tnt/dm/erp/companies/public/claims/custom-multiple-company-access/backoffice-ep?claimant_entity_hdr_guid=' + guid;
    }
    return this.httpClient.get<BasicApiResponseModel<MultiAccessCompanyContainer>>(url, this.getHttpHeader(visa));
  }

}


